import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";

export function useLitigeOptions() {
  const [o, setO] = useState(null);
  useEffect(() => { api.get("/litiges/options").then((r) => setO(r.data)).catch(() => setO({ statuses: [], motifs: [], avocats: [], protocols: [] })); }, []);
  return o;
}

const L = ({ label, children, wide }) => <label className={`block text-xs text-norea-textMuted space-y-1 ${wide ? "md:col-span-2" : ""}`}><span>{label}</span>{children}</label>;

export default function LitigeFields({ opts, v, onChange }) {
  const set = (k) => (e) => onChange({ ...v, [k]: e.target.value });
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-3" data-testid="litige-fields">
      <L label="Motif du litige"><select className="input-field w-full" value={v.motif || ""} onChange={set("motif")} data-testid="litige-motif">
        <option value="">—</option>{(opts?.motifs || []).map((m) => <option key={m}>{m}</option>)}</select></L>
      <L label="Montant réclamé (€)"><input type="number" className="input-field w-full" value={v.montant_reclame ?? ""} onChange={set("montant_reclame")} data-testid="litige-montant" /></L>
      <L label="Avocat (Annuaire → Avocats)" wide><select className="input-field w-full" value={v.avocat_id || ""} onChange={set("avocat_id")} data-testid="litige-avocat">
        <option value="">—</option>{(opts?.avocats || []).map((a) => <option key={a.id} value={a.id}>{a.name}{a.email ? ` — ${a.email}` : " (sans email)"}</option>)}</select></L>
      <L label="Description du litige" wide><textarea className="input-field w-full min-h-[110px]" value={v.description || ""} onChange={set("description")} data-testid="litige-description" /></L>
    </div>
  );
}

export const litigePayload = (v) => ({ motif: v.motif || null, description: v.description || "", montant_reclame: v.montant_reclame === "" || v.montant_reclame == null ? null : Number(v.montant_reclame),
  avocat_id: v.avocat_id || null });
